import { Select } from "antd";
import { SelectValue } from "antd/lib/select";
import { observer } from "mobx-react";
import NumberInKimWithThemeStore from "../../stores/task/number-in-kim-with-theme";
import { useEffect } from "react";

const NumberInKimWithTheme: React.FC<{ numberWithTheme: NumberInKimWithThemeStore }> = ({ numberWithTheme }) => {

    const { Option } = Select;

    useEffect(() => {
        if (numberWithTheme.isNotLoaded()) {
            numberWithTheme.loadDictionaries();
        }
    }, [numberWithTheme, numberWithTheme.numberInKim, numberWithTheme.theme]);

    const handleNumberChange = (value: SelectValue) => {
        numberWithTheme.selectNumberInKim(value as string);
    }

    const handleThemeChange = (value: SelectValue) => {
        numberWithTheme.theme.selectItem(value as string);
    }

    return (
        <div>
            <Select
                placeholder="номер в КИМ"
                optionLabelProp="label"
                onChange={handleNumberChange}
                value={numberWithTheme.numberInKim?.selectedItem}
                className="filter__item"
            >
                {numberWithTheme.numberInKim.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
            </Select>
            <Select
                placeholder="тема"
                optionLabelProp="label"
                onChange={handleThemeChange}
                value={numberWithTheme.theme?.selectedItem}
                className="filter__item"
            >
                {numberWithTheme.theme.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
            </Select>
        </div>
    );
}

export default observer(NumberInKimWithTheme);
